import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React from 'react'

import { DashboardRangePicker } from './range-picker'

export const UserResourceDashboardLayout: React.FC<{}> = ({ children }) => {
  return (
    <div className='mx-auto space-y-6 max-w-360 overflow-x-auto'>
      <DashboardRangePicker />
      <div className='space-y-12'>{children}</div>
    </div>
  )
}

export const UserResourceDashboardContentCard: React.FC<{
  title: string
  titleInfo?: string
  operations?: React.ReactNode
}> = ({ title, titleInfo, operations, children }) => {
  return (
    <div className='space-y-4'>
      <div className='flex font-medium text-xl justify-between'>
        <div className='flex gap-1 items-baseline'>
          {title}
          {titleInfo ? (
            <Tooltip title={titleInfo}>
              <InfoCircleOutlined className='cursor-pointer text-sm' size={14} />
            </Tooltip>
          ) : null}
        </div>
        {operations}
      </div>
      <div className='px-4'>{children}</div>
    </div>
  )
}
